module.exports = __webpack_public_path__ + "static/media/Gallery-9.096d15fd.jpg";